(ns common.db.effects.dom
  "Deprecated: avoid this and use
  React effect hooks and such instead."
  {:deprecated true}
  (:require [re-frame.core :as rf]))

(rf/reg-fx :dom/add-event-listener
  (fn [{:keys [^js target event-name listener]}]
    (.addEventListener target event-name listener)))

(rf/reg-fx :dom/remove-event-listener
  (fn [{:keys [^js target event-name listener]}]
    (.removeEventListener target event-name listener)))

